import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';

import { isLoggedIn } from '../api/Auth';
import { APIupdateUserSettings } from '../api/User';

import CollectionAddModal from '../components/Collections/AddModalV2';
import DashboardHeader from '../components/Dashboard/Header';
import DashboardStatsOverview from '../components/Dashboard/StatsOverview';
import DashboardWidgetCarousel from '../components/Dashboard/WidgetCarousel';
import DashboardWidgetRecentFiles from '../components/Dashboard/WidgetRecentFiles';
import DashboardWidgetSuggested from '../components/Dashboard/WidgetSuggested';
import DashboardWidgetRecentCollections from '../components/Dashboard/WidgetRecentCollections';
import DashboardWidgetNotifications from '../components/Dashboard/WidgetNotifications';
import DashboardWidgetFavoriteFiles from '../components/Dashboard/WidgetFavoriteFiles';
import DashboardWidgetFeaturedRecentCollections from '../components/Dashboard/WidgetFeaturedCollections';
import CollectionPreview from '../components/CollectionPreview';
import Onboarding from '../components/Dashboard/Onboarding/Onboarding';

import { resizeSplitContentContainer } from '../helpers/App';
import { getDashboardAvailableComponents } from '../helpers/Dashboard';
import { getUserSetting } from '../helpers/Settings';

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      userWidgets: getUserSetting('dashboard_widgets') || [],
      saving: false,
    };

    this.handleToggleUserWidget = this.handleToggleUserWidget.bind(this);
  }

  componentDidMount() {
    resizeSplitContentContainer();
  }

  componentDidUpdate(prevProps) {
    const { profile } = this.props;
    const { profile: prevProfile } = prevProps;

    if (profile && profile.uuid && (!prevProfile || !prevProfile.uuid)) {
      this.setState({ userWidgets: getUserSetting('dashboard_widgets') });
    }
  }

  handleToggleUserWidget(widgetId) {
    this.setState(prevState => ({
      userWidgets: prevState.userWidgets.includes(widgetId) ?
        prevState.userWidgets.filter(uw => (uw !== widgetId)) :
        prevState.userWidgets.concat([widgetId]),
    }), () => {
      const { profile } = this.props;
      const { userWidgets } = this.state;
      APIupdateUserSettings(profile.uuid, { dashboard_widgets: userWidgets });
    });
  }

  render() {
    const {
      profile,
      sidebarCollectionOpen,
    } = this.props;
    const {
      userWidgets,
      saving,
    } = this.state;

    if (!isLoggedIn() || !profile) {
      return null;
    }

    const dashboardUserWidgets = getUserSetting('dashboard_widgets') || [];
    const availableComponents = getDashboardAvailableComponents().map(c => c.slug);
    const dashboardUserOrder = dashboardUserWidgets
      .filter(c => c.selected && availableComponents.includes(c.slug)) || [];
    const dashboardUserSlugs = dashboardUserWidgets
      .filter(c => availableComponents.includes(c.slug)).map(c => c.slug);

    const unusedElementsLayout = getDashboardAvailableComponents()
      .filter(available => !dashboardUserSlugs.includes(available.slug))
      .map((c, i) => ({
        i: c.slug,
        x: 0,
        y: dashboardUserOrder.length + i,
        w: c.default_width || 12,
        h: c.default_height || 1,
        minW: c.min_width || 2,
        maxH: 3,
        ...c,
      }));

    const dashboardOrder = [...dashboardUserOrder, ...unusedElementsLayout];

    return (
      <div className={`main-content dashboard-content split-content${sidebarCollectionOpen ? ' split-content-active' : ''}`}>
        <div className="split-content-wrapper">
          <Container fluid id="dashboard-container" className="dashboard-container">
            <DashboardHeader
              profile={profile}
              saving={saving}
              userWidgets={userWidgets}
              handleToggleUserWidget={this.handleToggleUserWidget}
            />
            <div className="content-wrapper onboarding-wrapper">
              <Onboarding />
            </div>
            <DashboardWidgetCarousel />
            <div className="content-wrapper dashboard-wrapper">
              {dashboardOrder.map(({
                slug, x, y, w, h,
              }) => (
                <div
                  key={slug}
                  id={`dashboard-component-${slug}`}
                  style={{
                    gridColumn: `${x + 1} / span ${w}`,
                    gridRow: `${y + 1} / span ${h}`,
                  }}
                >
                  {slug === 'suggestions' && (
                    <DashboardWidgetSuggested />
                  )}
                  {slug === 'recent-files' && (
                    <DashboardWidgetRecentFiles />
                  )}
                  {slug === 'recent-collections' && (
                    <DashboardWidgetRecentCollections />
                  )}
                  {slug === 'notifications' && (
                    <DashboardWidgetNotifications />
                  )}
                  {slug === 'stats' && (
                    <DashboardStatsOverview />
                  )}
                  {slug === 'favorite-files' && (
                    <DashboardWidgetFavoriteFiles />
                  )}
                  {slug === 'favorite-collections' && (
                    <DashboardWidgetFeaturedRecentCollections />
                  )}
                </div>
              ))}
            </div>
            <CollectionAddModal />
          </Container>
          <CollectionPreview />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  sidebarCollectionOpen: state.Collections.sidebarCollectionOpen,
});

Dashboard.propTypes = {
  profile: PropTypes.object,
  sidebarCollectionOpen: PropTypes.bool.isRequired,
};

Dashboard.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(Dashboard);
